import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 16px;
  line-height: 30px;
  color: #2d3446;
  font-family: 'Roboto';
  font-weight: 500;
  && label {
    font-size: 16px;
    line-height: 30px;
    color: #2d3446;
    font-family: 'Roboto';
    font-weight: 500;
  }
  .field-container {
    margin-bottom: 20px;
  }
`;
